import {IItem, IComment} from '../../Interfaces';

export const AUTH_START = 'AUTH_START';
export const AUTH_END = 'AUTH_END';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_CLEAN_UP = 'AUTH_CLEAN_UP';

export const VERIFY_START = 'VERIFY_START';
export const VERIFY_SUCCESS = 'VERIFY_SUCCESS';
export const VERIFY_FAIL = 'VERIFY_FAIL';

export const RECOVERY_START = 'RECOVERY_START';
export const RECOVERY_SUCCESS = 'RECOVERY_SUCCESS';
export const RECOVERY_FAIL = 'RECOVERY_FAIL';

interface AuthStartAction {
  type: typeof AUTH_START;
}
interface AuthEndAction {
  type: typeof AUTH_END;
}
interface AuthSuccessAction {
  type: typeof AUTH_SUCCESS;
}
interface AuthFailAction {
  type: typeof AUTH_FAIL;
  payload: string;
}
interface AuthCleanUpAction {
  type: typeof AUTH_CLEAN_UP;
}

interface VerifyStartAction {
  type: typeof VERIFY_START;
}
interface VerifySuccessAction {
  type: typeof VERIFY_SUCCESS;
}
interface VerifyFailAction {
  type: typeof VERIFY_FAIL;
  payload: string;
}

interface RecoveryStartAction {
  type: typeof RECOVERY_START;
}
interface RecoverySuccessAction {
  type: typeof RECOVERY_SUCCESS;
}
interface RecoveryFailAction {
  type: typeof RECOVERY_FAIL;
}

export type AuthActionTypes =
  | AuthStartAction
  | AuthEndAction
  | AuthSuccessAction
  | AuthFailAction
  | AuthCleanUpAction
  | VerifyStartAction
  | VerifySuccessAction
  | VerifyFailAction;

export const LOCAL_CLEAN_UP = 'LOCAL_CLEAN_UP';
export const LOCAL_CLEAN_COMMENTS = 'LOCAL_CLEAN_COMMENTS';

export const PAGINATE_START = 'PAGINATE_START';
export const PAGINATE_SUCCESS = 'PAGINATE_SUCCESS';
export const PAGINATE_FAIL = 'PAGINATE_FAIL';

export const GET_PRODUCT_START = 'GET_PRODUCT_START';
export const GET_PRODUCT_SUCCESS = 'GET_PRODUCT_SUCCESS';
export const GET_PRODUCT_FAIL = 'GET_PRODUCT_FAIL';

export const ADD_COMMENT_START = 'ADD_COMMENTS_START';
export const ADD_COMMENT_SUCCESS = 'ADD_COMMENTS_SUCCESS';
export const ADD_COMMENT_FAIL = 'ADD_COMMENTS_FAIL';

export const PAGINATE_COMMENT_START =
  'PAGINATE_COMMENTS_START';
export const PAGINATE_COMMENT_SUCCESS =
  'PAGINATE_COMMENTS_SUCCESS';
export const PAGINATE_COMMENT_FAIL =
  'PAGINATE_COMMENTS_FAIL';

interface LocalCleanAction {
  type: typeof LOCAL_CLEAN_UP;
}

interface LocalCleanCommentsAction {
  type: typeof LOCAL_CLEAN_COMMENTS;
}

interface PaginateStartAction {
  type: typeof PAGINATE_START;
}
interface PaginateSuccessAction {
  type: typeof PAGINATE_SUCCESS;
  payload: IItem[];
}
interface PaginateFailAction {
  type: typeof PAGINATE_FAIL;
  payload: string;
}

interface GetItemStartAction {
  type: typeof GET_PRODUCT_START;
}
interface GetItemSuccessAction {
  type: typeof GET_PRODUCT_SUCCESS;
  payload: IItem;
}
interface GetItemFailAction {
  type: typeof GET_PRODUCT_FAIL;
  payload: string;
}

interface AddCommentStartAction {
  type: typeof ADD_COMMENT_START;
}
interface AddCommentSuccessAction {
  type: typeof ADD_COMMENT_SUCCESS;
  payload: IComment;
}
interface AddCommentFailAction {
  type: typeof ADD_COMMENT_FAIL;
  payload: string;
}

interface PaginateCommentStartAction {
  type: typeof PAGINATE_COMMENT_START;
}
interface PaginateCommentSuccessAction {
  type: typeof PAGINATE_COMMENT_SUCCESS;
  payload: IComment[];
}
interface PaginateCommentFailAction {
  type: typeof PAGINATE_COMMENT_FAIL;
  payload: string;
}

export type LocalActionTypes =
  | PaginateStartAction
  | PaginateSuccessAction
  | PaginateFailAction
  | LocalCleanAction
  | LocalCleanCommentsAction
  | GetItemStartAction
  | GetItemSuccessAction
  | GetItemFailAction
  | AddCommentStartAction
  | AddCommentSuccessAction
  | AddCommentFailAction
  | PaginateCommentStartAction
  | PaginateCommentSuccessAction
  | PaginateCommentFailAction;

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

interface toggleSidebarAction {
  type: typeof TOGGLE_SIDEBAR;
  payload: boolean;
}

export type UtilityActionTypes = toggleSidebarAction;
